(function () {
  'use strict';

  var GRACE_PATH = '/collections/grace-wig';
  var SEARCHANISE_KEY = 'rb_filter_option_ba2a9c6c8c77e03f83ef8bf543612275';
  var DEBUG_KEY = 'graceRedirectDebug';
  var STYLES = [
    '12" Halle',
    '13" Victoria',
    '16" Naomi',
    '19" Nicole',
    '22" Reese',
    '24" Gisele',
    '26" Amber'
  ];

  var pathname = window.location.pathname.replace(/\/$/, '');
  if (pathname !== GRACE_PATH) return;

  var params = new URLSearchParams(window.location.search);
  var debugEnabled = params.get(DEBUG_KEY) === '1';

  function debug() {
    if (!debugEnabled || !window.console) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[Grace URL redirect]');
    window.console.info.apply(window.console, args);
  }

  function safelyDecode(value) {
    var decoded = String(value || '').replace(/\+/g, ' ');
    if (decoded.indexOf('%') === -1) return decoded;

    try {
      return decodeURIComponent(decoded);
    } catch (error) {
      return decoded;
    }
  }

  function normalize(value) {
    return safelyDecode(value)
      .replace(/[\u201c\u201d\u201e\u201f\u2033\u02ba]/g, '"')
      .replace(/[\u2018\u2019\u2032]/g, "'")
      .replace(/'{2}/g, '"')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();
  }

  function matchStyle(value) {
    var normalized = normalize(value);
    if (!normalized) return '';

    return (
      STYLES.find(function (style) {
        return normalize(style) === normalized;
      }) || ''
    );
  }

  function findFallbackSearchaniseValue() {
    var fallback = null;
    params.forEach(function (value, key) {
      if (
        fallback === null &&
        key.indexOf('rb_filter_option_') === 0 &&
        key !== SEARCHANISE_KEY &&
        matchStyle(value)
      ) {
        fallback = value;
      }
    });
    return fallback;
  }

  var oldStyleValue = params.get('filter.style');
  var exactSearchaniseValue = params.get(SEARCHANISE_KEY);
  var fallbackSearchaniseValue =
    exactSearchaniseValue === null ? findFallbackSearchaniseValue() : null;
  var detectedSearchaniseValue =
    exactSearchaniseValue !== null ? exactSearchaniseValue : fallbackSearchaniseValue;

  var matchedSearchaniseStyle = matchStyle(detectedSearchaniseValue);
  var matchedOldStyle =
    detectedSearchaniseValue === null ? matchStyle(oldStyleValue) : '';
  var matchedStyle = matchedSearchaniseStyle || matchedOldStyle;

  debug('current URL', window.location.href);
  debug('detected filter.style', oldStyleValue);
  debug('detected rb_filter_option value', detectedSearchaniseValue);
  debug('matched style', matchedStyle || '(none)');

  if (!matchedStyle) {
    debug('redirect skipped: no recognized Grace style');
    return;
  }

  var targetUrl =
    GRACE_PATH +
    '?page=1&' +
    SEARCHANISE_KEY +
    '=' +
    encodeURIComponent(matchedStyle);
  var currentUrl = pathname + window.location.search;

  debug('target URL', targetUrl);

  if (currentUrl === targetUrl) {
    debug('redirect skipped: URL is already canonical');
    return;
  }

  debug('redirect performed');
  window.location.replace(targetUrl);
})();
